export default __webpack_public_path__ + "static/media/cookie.eab00f88.png";